module.exports = __webpack_public_path__ + "static/media/404_page_graphic_transparent.150a01ea.svg";